import { API_ROUTES } from "./apiRoutes";
import api from "./axiosInstance";

export const fetchContainer = async (data) => {
  const res = await api.get(API_ROUTES.CONTAINER.LIST, {
    params: { ...data },
  });
  return res.data;
};
export const fetchContainerStatus = async (data) => {
  const res = await api.get(API_ROUTES.CONTAINER.STATUS, {
    params: { ...data },
  });
  return res.data;
};
export const createContainerNo = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.GENERATOR_NO, data);
  return res.data;
};

export const createContainer = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.CREATE, data);
  return res.data;
};
export const updateContainer = async (data) => {
  const res = await api.put(API_ROUTES.CONTAINER.EDIT, data);
  return res.data;
};
export const addItemsContainer = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.ADDITEM, data);
  return res.data;
};

export const fetchContainerDetails = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.INFO, data);
  return res.data;
};

export const fetchOrderItems = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.ORDER_ITEMS_LIST, data);
  return res.data;
};

export const assignitemApi = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.ASSIGN_ITEM, data);
  return res.data;
};

export const unassignitemApi = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.UNASSIGN_ITEM, data);
  return res.data;
};

export const splitContainerItemApi = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.SPLIT_ITEM, data);
  return res.data;
};

export const reverseSplitContainerItemApi = async (data) => {
  const res = await api.post(API_ROUTES.CONTAINER.REVERSE_SPLIT_ITEM, data);
  return res.data;
};

// 🔹 change status
export const changeContainerStatusApi = async (data) => {
  const res = await api.put(API_ROUTES.CONTAINER.EDIT, data);
  return res.data;
};

export const deleteContainerItemApi = async (data) => {
  const { _id } = data;
  const res = await api.delete(API_ROUTES.CONTAINER.DELETE_ITEM(_id));
  return res.data;
};
